import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getPractitionerProfile } from "../../actions/profileAction";
import Avatar from "../../assets/images/default-avatar.jpg";
import BreadCrumb from "../../components/Breadcrumb";
import InfoItem from "../../components/InfoItem";
import { BUCKET_NAME } from "../../constants/states";
const PractitionerInfo = () => {
  const dispatch = useDispatch();
  const practitionerId = useSelector(
    (state) => state.role.activePractitionerId
  );
  const practitionerInfo = useSelector(
    (state) => state.profile.practitionerProfile
  );

  useEffect(() => {
    if (practitionerId > 0) {
      dispatch(getPractitionerProfile(practitionerId));
    }
  }, [practitionerId, dispatch]);

  return (
    <div className="profile-page">
      <BreadCrumb pageName="Practitioner" />

      <h3 className="page-title">Practitioner Profile</h3>
      <div className="row">
        <div className="personal-section mt-3 col-md-6">
          <h5 className="profile-title">personal information</h5>
          <hr className="separator" />
          <div className="avatar">
            <img
              style={{
                width: "100px",
                height: "100px",
                objectFit: "contain",
              }}
              src={
                practitionerInfo && practitionerInfo.Has_Profile_Picture
                  ? `https://storage.googleapis.com/${BUCKET_NAME}/user/${
                      practitionerInfo.user_id
                    }.png?${Math.random()}`
                  : Avatar
              }
              alt="user"
            />
          </div>
          <InfoItem
            title="First Name"
            value={practitionerInfo && practitionerInfo.first_name}
          />
          <InfoItem
            title="Last Name"
            value={practitionerInfo && practitionerInfo.last_name}
          />
          <InfoItem
            title="Email"
            value={practitionerInfo && practitionerInfo.clinic_email}
          />
          <InfoItem
            title="Phone"
            value={practitionerInfo && practitionerInfo.clinic_phone}
          />
          <InfoItem
            title="City"
            value={practitionerInfo && practitionerInfo.clinic_city}
          />
          <InfoItem
            title="State"
            value={practitionerInfo && practitionerInfo.clinic_state}
          />
          <InfoItem
            title="Apt"
            value={practitionerInfo && practitionerInfo.clinic_address_2}
          />
          <InfoItem
            title="Zip"
            value={practitionerInfo && practitionerInfo.clinic_zip}
          />
        </div>
        <div className="personal-section mt-3 col-md-6">
          <h5 className="profile-title">Clinic information</h5>
          <hr className="separator" />
          <InfoItem
            title="Clinic Name"
            value={practitionerInfo && practitionerInfo.clinic_name}
          />
          <InfoItem
            title="Email"
            value={practitionerInfo && practitionerInfo.clinic_email}
          />
          <InfoItem
            title="Website"
            value={practitionerInfo && practitionerInfo.clinic_url}
          />
          <InfoItem
            title="Street Address"
            value={practitionerInfo && practitionerInfo.clinic_address_1}
          />
          <InfoItem
            title="City"
            value={practitionerInfo && practitionerInfo.clinic_city}
          />
          <InfoItem
            title="State"
            value={practitionerInfo && practitionerInfo.clinic_state}
          />
          <InfoItem
            title="Apt"
            value={practitionerInfo && practitionerInfo.clinic_address_2}
          />
          <InfoItem
            title="Zip"
            value={practitionerInfo && practitionerInfo.clinic_zip}
          />
        </div>
      </div>
    </div>
  );
};
export default PractitionerInfo;
